/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */






// $( document ).ready(function() {


//   $( ".template-product .thisbtns a" ).removeClass( "trigger_pop" );

//    $(".HorizontalList.HorizontalList--spacingExtraLoose li:last-child a.Heading.u-h6").attr("href", "javascript:void( window.open( 'https://form.jotform.com/220384202960045', 'blank', 'scrollbars=yes, toolbar=no, width=700, height=500' ) )")

//     $(".thisbtns li .trigger_pop").attr("href", "javascript:void( window.open( 'https://form.jotform.com/220384202960045', 'blank', 'scrollbars=yes, toolbar=no, width=700, height=500' ) )")

//    $(".Collapsible:last-child .Collapsible__Button.Heading.Link.Link--primary.u-h6").attr("href", "javascript:void( window.open( 'https://form.jotform.com/220384202960045', 'blank', 'scrollbars=yes, toolbar=no, width=700, height=500' ) )")

// });


$( document ).ready(function() {


  
   
  $(".HorizontalList.HorizontalList--spacingExtraLoose li:last-child a.Heading.u-h6")
   .attr("href", "javascript:void( window.open( 'https://form.jotform.com/220721280143443', 'target=_blank', 'scrollbars=yes, toolbar=no, width=900, height=600' ) )")
  
  $("#section-16344771578d953904 .thisbtns a.trigger_pop:first-child")
   .attr("href", "javascript:void( window.open( 'https://form.jotform.com/220721280143443', 'target=_blank', 'scrollbars=yes, toolbar=no, width=900, height=600' ) )")
  
  $(".Collapsible:last-child .Collapsible__Button.Heading.Link.Link--primary.u-h6")
   .attr("href", "javascript:void( window.open( 'https://form.jotform.com/220721280143443', 'target=_blank', 'scrollbars=yes, toolbar=no, width=900, height=600' ) )")

   
   
   
   
   
});



$( document ).ready(function() {

		jQuery(".CollectionList > a").each(function(){

          let element = jQuery(this);

          console.log(element.attr('href'));

              if(element.attr('href') == '' ){

                  element.addClass("display_none");

              }

          });

});
